<shared-confirmation [type]="null" size="xxlg" [center]="false"></shared-confirmation>

<ng-template #preHeader>
    EMAIL SENT
</ng-template>
<shared-auth-header [preHeaderMarginTop]="preHeaderMarginTop" [preHeader]="preHeader" [description]="description">
    Check your emails!
</shared-auth-header>
<ng-template #description>
    We have sent an email to {{email$ | async}}. Follow the steps to update your password.
</ng-template>

<shared-form-for-forgot-password-sent [modal]="true"></shared-form-for-forgot-password-sent>